import auth from './auth';

const transformWatchlistName = (watchlistName: string) => {
  if (watchlistName.toLowerCase().trim() === 'all') {
    return 'All Watchlist';
  }

  return watchlistName;
};

const checkDefaultWatchlist = (watchlistId) => {
  // @ts-ignore
  const { watchlist_id: defaultWatchlist } = auth.getUserAccess();

  return Number(watchlistId) === Number(defaultWatchlist);
};

// eslint-disable-next-line import/prefer-default-export
export { transformWatchlistName, checkDefaultWatchlist };
